import React, { useState } from "react";

// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";

import {
  ESTATE_URL,
  ZONE_FETCH_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
} from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";


let model = [
  { id: "company_name", label: "Company", type: "string" },
  { id: "zone_code", label: "Zone Code", type: "string" },
  { id: "zone_name", label: "Zone Name", type: "string" },
  { id: "state", label: "State", type: "string" },
  { id: "region_code", label: "Region Code", type: "string" },
  { id: "region_name", label: "Region Name", type: "string" },
  { id: "estate_code", label: "Estate Code", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "division_code", label: "Division Code", type: "string" },
  { id: "division_name", label: "Division Name", type: "string" },
  { id: "block_code", label: "Block Code", type: "string" },
  { id: "block_name", label: "Block Name", type: "string" },
  { id: "year", label: "Year", type: "string" },
  { id: "status_label", label: "Status", type: "string" },
];

export default function EstateList() {
  const [filterValues, setFilterValues] = useState({});
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const filterInitialValues = {
    company: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    year: "",
  };
  
const filterFields = [
  {
    type: "reactselect",
    name: "company",
    label: "Company",
    proxyUrl: COMPANY_FETCH_URL,
    getValue: (e) => getCompanyValues(e, setDisableZone),
    paginated: true,


  },
  {
    type: "reactselect",
    name: "zone",
    label: "Zone",
    proxyUrl: ZONE_FETCH_URL,
    getValue: (e) => getZoneValues(e, setDisableRegion),
    paginated: false,
    isPaginationEnabled: false,
    isAllowablesEnabled: false,
    disabled:disableZone,
    optionsDependsOn: "company",
  },
  {
    type: "reactselect",
    name: "region",
    label: "Region",
    proxyUrl: REGION_FETCH_URL,
    paginated: false,
    isPaginationEnabled: false,
    isAllowablesEnabled: false,
    disabled:disableRegion,
    getValue: (e) => getRegionValues(e, setDisableEstate),
    optionsDependsOn: "zone",
  },
  {
    type: "reactselect",
    name: "estate",
    label: "Estate",
    proxyUrl: ESTATE_FETCH_URL,
    paginated: false,
    isPaginationEnabled: false,
    isAllowablesEnabled: false,
    disabled:disableEstate,
    getValue: (e) => getEstateValues(e, setDisableDivision),

    optionsDependsOn: "region",
  },
  {
    type: "reactselect",
    name: "division",
    label: "Division",
    proxyUrl: DIVISION_FETCH_URL,
    paginated: true,
    disabled:disableDivision,
    getValue: (e) => getDivisonValues(e, setDisableBlock),

    optionsDependsOn: "estate",
  },
  {
    type: "reactselect",
    name: "block",
    label: "Block",
    proxyUrl: BLOCK_FETCH_URL,
    paginated: true,
    disabled:disableBlock,

    optionsDependsOn: "division",
  },
  {
    type: "input",
    label: "Year",
    name: "year",
  },
  {
    type: "reactselect",
    label: "Status",
    name: "status",
    outerOptions: [
      { id: "active", name: "ACTIVE" },
      { id: "inactive", name: "INACTIVE" },
    ],
  },
];

const pageNumberDropdown = true;
const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  
  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />

      <Table
        proxyURL={ESTATE_URL}
        model={model}
        excelExport={{ fileName: "EstateData" }}
        filterValues={filterValues}
        noFilter
        noAddButton
        pageNumberDropdown={pageNumberDropdown}

      />
    </div>
  );
}
